import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.80281 17.9472C2.2324 16.3768 2.2324 13.8306 3.80281 12.2602L6.76024 9.30281C8.33065 7.7324 10.8768 7.7324 12.4472 9.30281C14.0176 10.8732 14.0176 13.4194 12.4472 14.9898L9.48976 17.9472C7.91935 19.5176 5.37322 19.5176 3.80281 17.9472Z",
      class: "faded-stroke",
      "stroke-width": "3.25"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.5528 14.6972C9.9824 13.1268 9.9824 10.5806 11.5528 9.01024L14.5102 6.05281C16.0806 4.4824 18.6268 4.4824 20.1972 6.05281C21.7676 7.62322 21.7676 10.1694 20.1972 11.7398L17.2398 14.6972C15.6694 16.2676 13.1232 16.2676 11.5528 14.6972Z",
      class: "primary-stroke",
      "stroke-width": "3.25"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.9849 11.875C12.0642 12.5752 11.8353 13.3037 11.2983 13.8407L9.88672 15.2523C10.043 15.4592 10.2154 15.6577 10.4039 15.8462C11.0287 16.471 11.7634 16.9187 12.5458 17.1894L13.5964 16.1388C14.1657 15.5696 14.5879 14.909 14.8633 14.2043C14.1055 14.3541 13.2893 14.1354 12.702 13.5481C12.2396 13.0856 12.0056 12.4811 12.0003 11.875H11.9849Z",
      class: "faded"
    }, null, -1)
  ])))
}
export default { render: render }